import { Injectable } from '@angular/core';
import { ContentService } from '@blk/cwp-ng-framework';
import { SaveSubscribeDialogDCR } from '@ddt-web/config';
import { ErrorPopupService, PopupDialogAction, PopupDialogActionOptions, PopupDialogObject, PopupDialogOptions } from '@ddt-web/error-handler';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action, select, Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap, withLatestFrom } from 'rxjs/operators';

import * as stateSelectors from '../../blk-model-subscription-manger.selectors';
import { UserDataHandlerService } from '../../services/store-data-loader.service';
import { UserDataService } from '../../services/user-data.service';
import * as actions from './saved-model-portfolios.actions';
import { SavedModelPortfoliosState } from './saved-model-portfolios.interfaces';

@Injectable()
export class SavedModelPortfoliosEffects {

	public failedMessage = PopupDialogObject.create({
		title: this.contentService.get('FAIL_MESSAGE_TITLE', SaveSubscribeDialogDCR.FAIL_MESSAGE_TITLE, SaveSubscribeDialogDCR),
		description: this.contentService.get('FAIL_MESSAGE_DESCRIPTION', SaveSubscribeDialogDCR.FAIL_MESSAGE_DESCRIPTION, SaveSubscribeDialogDCR),
		actions: [
			PopupDialogAction.create({
				description: this.contentService.get('FAIL_MESSAGE_ACTION_DESCRIPTION', SaveSubscribeDialogDCR.FAIL_MESSAGE_ACTION_DESCRIPTION, SaveSubscribeDialogDCR),
				dialogClass: 'save-subscribe-dialog',
				label: this.contentService.get('FAIL_MESSAGE_ACTION_LABEL', SaveSubscribeDialogDCR.FAIL_MESSAGE_ACTION_LABEL, SaveSubscribeDialogDCR),
				url: this.contentService.get('FAIL_MESSAGE_ACTION_URL', SaveSubscribeDialogDCR.FAIL_MESSAGE_ACTION_URL, SaveSubscribeDialogDCR),
				reload: null,
				config: null
			} as PopupDialogActionOptions)
		],
		success: false
	} as PopupDialogOptions);

	constructor(
		private actions$: Actions,
		private userDataService: UserDataService,
		private userDataHandler: UserDataHandlerService,
		public contentService: ContentService,
		private store$: Store<SavedModelPortfoliosState>,
		private errorPopupService: ErrorPopupService
	) { }

	
	public saveModelPortfolio: Observable<Action> = createEffect(() => this.actions$.pipe(
		ofType<actions.SaveModelApiRequest>(actions.SAVE_MODEL_API_REQUEST),
		switchMap(action => {
			console.log(`Saving in effect:  ${action.portfolioId}`);
			return this.userDataService.saveBlkModelPortfolioToAPI(action.portfolioId, action.origin).pipe(
				map(responseJson => {
					const newMapping: Map<string, string> = this.userDataHandler.getNewMapping(responseJson, action.portfolioId);
					if (newMapping.size) {
						return {
							type: actions.ADD_SAVED_STORE_MAPPING,
							newMapping: newMapping
						} as Action;
					} else {
						this.errorPopupService.openResponseMessageDialog(this.failedMessage, false);
						return {} as Action;
					}
				})
			);
		}),
		catchError(error => {
			console.error(`[ERROR] Failed to subscribe to model: ${error}`);
			this.errorPopupService.openResponseMessageDialog(this.failedMessage, false);
			return of({} as Action);
		})
	));

	
	public unsubscribeModelPortfolio = createEffect(() => this.actions$.pipe(
		ofType<actions.UnsaveModelApiRequest>(actions.UNSAVE_MODEL_API_REQUEST),
		withLatestFrom(this.store$.pipe(select(stateSelectors.getSavedModelPortfolioIdMappings))),
		switchMap(([action, savedMappings]) => {
			const uniqueId: string = savedMappings.get(action.portfolioId);
			console.log(`Unsaving in effect, portfolioId:  ${action.portfolioId}, uniqueId: ${uniqueId}`);
			return this.userDataService.unsaveBlkModelPortfolioToAPI(uniqueId).pipe(
				map(responseJson => {
					const successful: boolean = this.userDataHandler.isDeleteSuccessful(responseJson);

					if (successful) {
						return {
							type: actions.REMOVE_SAVED_STORE_MAPPING,
							portfolioId: action.portfolioId
						} as Action;
					} else {
						this.errorPopupService.openResponseMessageDialog(this.failedMessage, false);
						return {} as Action;
					}
				})
			);
		}),
		catchError(error => {
			this.errorPopupService.openResponseMessageDialog(this.failedMessage, false);
			return of({} as Action);
		})
	));
}

